import Vue from "vue"
import VueI18n from "vue-i18n"

import daLang from "./da"
import enLang from "./en"

Vue.use(VueI18n)

const messages = {
	da: {
		...daLang
	},
	en: {
		...enLang
	}
}

export const getLocale = () =>
{
	// TODO: Get language from user settings
	/*
	const cookieLanguage = getLanguage()
	if (cookieLanguage)
	{
		return cookieLanguage
	}

	const language = navigator.language.toLowerCase()
	const locales = Object.keys(messages)
	for (const locale of locales)
	{
		if (language.indexOf(locale) > -1)
		{
			return locale
		}
	}
	*/

	// Default language is danish
	return "da"
}

const i18n = new VueI18n({
	locale: getLocale(),
	messages
})

export default i18n
